import { forwardRef } from "react";
import cx from "clsx";

interface LinkProps {
  className?: string;
  href: string;
  children?: string;
  newTab?: boolean;
}

export const ExternalLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, href, newTab, children }, ref) => {
    return (
      <a
        href={href}
        className={cx(
          "text-link-colour underline hover:text-link-hover-colour",
          className,
        )}
        ref={ref}
        target={newTab !== false ? "_blank" : undefined}
        rel={newTab !== false ? "noopener noreferrer" : undefined}
      >
        {children}
      </a>
    );
  },
);

ExternalLink.displayName = "ExternalLink";
